import React from 'react'
import { useSession } from 'packages/@slerp/accounts'
import { useMessageStore } from 'hooks/useGlobalContext/useMessageStore'
import { LIST_INTEGRATIONS } from 'router/queries'
import { ShipdayIntegration } from 'components/Integrations/Manage/ManageShipday/types'
import { useIntegration } from 'hooks/useGlobalContext/useIntegration'
import { PARTNER_SLUGS } from 'components/Integrations/constants'
import { LoaderProps } from './types'
import { useFetchOnce } from './useFetchOnce'

const PROVIDER = PARTNER_SLUGS.SHIPDAY

export const ShipdayIntegrationsLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const { merchant } = useSession()
  const { addMessage } = useMessageStore()
  const {
    shipdayIntegrations,
    setShipdayIntegrations,
    setRefetchShipdayIntegrations
  } = useIntegration()

  const { isLoaded } = useFetchOnce<{
    listIntegrations: ShipdayIntegration[]
  }>({
    query: LIST_INTEGRATIONS,
    skip: !merchant?.id || shipdayIntegrations.length > 0,
    variables: { merchant_id: merchant?.id, provider: PROVIDER },
    onError: () => {
      addMessage({ type: 'error', content: 'Failed to load integrations' })
    },
    onData: (data) => {
      if (data.listIntegrations) {
        setShipdayIntegrations(data.listIntegrations)
      }
    },
    onRefetch: (refetch) =>
      setRefetchShipdayIntegrations(
        (() => refetch) as unknown as () => Promise<unknown>
      ),
    isReady: (loading) => !merchant?.id || !loading,
    isParentLoaded
  })

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
